import React from "react";

export function ProgressBar(props){

    return (
        <div className="progress w-100" style={{height:props.height, borderRadius:(props.square ? 0 : "")}}>
            <div className={"progress-bar progress-bar-striped progress-bar-animated "} role="progressbar" aria-label="Basic example" aria-valuenow="0" style={{width:props.progress+"%", backgroundColor:props.color}}
                 aria-valuemin="0" aria-valuemax="100">
                {
                    props.show !== false ?
                        <label className={"fs-4"}>
                            {props.progress + "%"}
                        </label>
                        :
                        null
                }

            </div>
        </div>

    );

}